$(document).on('click', '.btn-main-product', function() {
  var vid = $(this).data('vid');
  var qty = 1;

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: vid,
      quantity: qty
    },
    dataType: "json",
    success: function(response) {
      var modal = new bootstrap.Modal(document.getElementById('shopping-cart'));
      modal.show();
      updateMiniCart();
      updateCartBubble();
    },
    error: function(error) {
      console.error("Add to cart failed:", error);
    }
  });
});




$(document).ready(function(){
  const WRAPPER = '.tf-product-info-choose-option';

  $(WRAPPER).on('click', '.all_swatches_class', function(){
    const $w = $(this).closest(WRAPPER);

    // get selected variant id directly
    const variantId = $(this).data('variant-id');

    // find the matching option in the select by data-id
    const $opt = $w.find('select.variant__s option').filter(function(){
      return $(this).data('id') == variantId;
    });

    if ($opt.length) {
      const vid    = $opt.data('id'),
            vqty   = $opt.data('qty'),
            vsku   = $opt.data('sku'),
            vstock = $opt.data('stock'),
            vprice = $opt.data('vprice'),
            vcprice = $opt.data('comp');


      $w.find('.varval')
        .val(vid)
        .attr('data-finalqty', vqty);
      $w.find('.add2crt').show();
      $w.find('.unavail, .p_sold_out').hide();

      const $btn = $w.find('.add2crt');
      if (vqty === 0) {
        $btn.hide();
        $w.find('.p_sold_out').show();
      } else {
        $btn.show();
        $btn.find('span').text('Add to bag');
      }

      $('.product_price').text("Rs. " + vprice);
      if (vcprice) {
      $('.product_compare_price').text("Rs. " + vcprice).show();
    
      const priceNum = parseFloat(vprice);
      const compNum = parseFloat(vcprice);
    
      if (!isNaN(priceNum) && !isNaN(compNum) && compNum > priceNum) {
        const discount = Math.round(((compNum - priceNum) / compNum) * 100);
        $('.compare_per').text(`-${discount}%`).show();
      } else {
        $('.compare_per').hide();
      }
    
    } else {
      $('.product_compare_price').hide();
      $('.compare_per').hide();
    }
      $w.find('.variant_sku .text-1').text(vsku);
      $w.find('.variant_availabilty .text-1').text(vstock ? 'In stock' : 'Out of stock');
    } else {
      $w.find('.add2crt, .p_sold_out').hide();
      $w.find('.unavail').show();
    }
  });

  $(WRAPPER).on('click', '.add2crt', function(e){
    e.preventDefault();
    const $w = $(this).closest(WRAPPER);
    const variantId = $w.find('.varval').val();
    const qty       = $w.find('.quantity-product').val();

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { id: variantId, quantity: qty },
      dataType: "json",
      success: function(){
        new bootstrap.Modal(document.getElementById('shopping-cart')).show();
        updateCartBubble();
      },
      error: function(err){
        const msg = err.responseJSON?.description || "Something went wrong.";
        $('.atc_errors').text(msg).show();
      }
    });



  });
});






function updateMiniCart() {
  $.get('/?section_id=shopping-cart', function (data) {
    const html = $('<div>').html(data);
    const newContent = html.find('.modal-shopping-cart .modal-dialog').html();
    $('#shopping-cart .modal-dialog').html(newContent);
    attachRemoveListeners();
    updateCartBubble();
  });
}

function attachRemoveListeners() {
  $('.tf-mini-cart-item .remove').on('click', function () {
    const $item = $(this).closest('.tf-mini-cart-item');
    const lineKey = $item.data('line-item-key');

    if (!lineKey) {
      console.warn('Line item key not found');
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: lineKey,
        quantity: 0
      },
      success: function (cart) {
        updateMiniCart();
        updateCartBubble();
      },
      error: function (err) {
        console.error('Error removing item', err);
      }
    });
  });


  $('a[href="/cart"]').on('click', function () {
    updateMiniCart();  
    updateCartBubble();
  });
}

$(document).ready(function () {
  attachRemoveListeners();
});


$('.nav-cart').on('click', function () {
  updateMiniCart();
  updateCartBubble();
  new bootstrap.Modal(document.getElementById('shopping-cart')).show();
})


function updateCartBubble() {
  $.getJSON('/cart.js', function(cart) {
    var itemCount = cart.item_count || 0;
    $('.count-box').text(itemCount);
  });
}
updateCartBubble();


$('.nav-search').on('click', function (e) {
  e.preventDefault();
  const link = $(this).find('a').attr('href');
  if (link) {
    window.location.href = link;
  }
})

document.querySelectorAll('a[href^="/account"]').forEach(a => {
    a.addEventListener("click", function(e) {
        const c = getValueFromCookiesOrLocalStorage(XGokwikCoreToken(window?.merchantInfo?.environment));
        if (c) { // logged in
            e.stopImmediatePropagation(); // stops the blocking handler
        }
    }, true); // use capture phase
});
document.body.addEventListener("click", function (e) {
    const a = e.target.closest("a");
    if (!a) return;

    // Skip handling if it's just a hash link for modal or scrolling
    if (a.getAttribute('data-bs-toggle')&& location.pathname.includes("account")) {
      e.stopImmediatePropagation();
        return; // Let Bootstrap handle it
    }
}, true); // use capture to run before library if needed


function changeLTE(event) {
  const value = event.target.closest("button")?.dataset.value;
  const targetInput = document.getElementById("Filter-Price-LTE");
  if(targetInput){
    targetInput.value = Number(value||"");
    targetInput.dispatchEvent(new Event("input", { bubbles: true }));
    targetInput.dispatchEvent(new Event("change", { bubbles: true }));
  }
}